var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M8.1 16.2V1.8H2.7a.9.9 0 0 0-.9.9v1.8a.9.9 0 1 1-1.8 0V2.7A2.7 2.7 0 0 1 2.7 0h12.6A2.7 2.7 0 0 1 18 2.7v1.8a.9.9 0 0 1-1.8 0V2.7a.9.9 0 0 0-.9-.9H9.9v14.4h2.7a.9.9 0 0 1 0 1.8H5.4a.9.9 0 0 1 0-1.8h2.7z", id: "svg566211866a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg566211866b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg566211866a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg566211866a" }),
      React.createElement(
        "g",
        { mask: "url(#svg566211866b)", fill: "currentColor" },
        React.createElement("path", { d: "M-1-1h20v20H-1z" })
      )
    )
  );
});